export const eventTypeColors = {

    'run': { //road run
        light: '#ffe5e5',   // soft blush
        mid: '#ff9f9f',     // vibrant red-orange
        dark: '#991f1f',    // deep crimson
    },
    'trail': {
        light: '#e0f2e9',   // misty forest green
        mid: '#6fbf73',     // mid-green trail vibe
        dark: '#2e5939',    // deep forest
    },
    'walk': {
        light: '#f9f9f9',   // gentle neutral
        mid: '#bcbcbc',     // soft grey for ease
        dark: '#4b4b4b',    // solid but relaxed charcoal
    },
    'hike': {
        light: '#f4ecd8',   // dusty mountain beige
        mid: '#b59b72',     // rugged earthy brown
        dark: '#5c4425',    // deep rock brown
    },
    'cycle': {
        light: '#fff9db',   // soft lemon yellow
        mid: '#ffe066',     // vibrant sunflower yellow
        dark: '#b38f00',    // earthy golden amber
    },
    'swim': {
        light: '#cceaff',
        mid: '#80c1ff',
        dark: '#24649b'
    },
    'yoga': {
        light: '#f4e9f9',   // soft lavender mist
        mid: '#caa0dd',     // tranquil lilac
        dark: '#6a4c82',    // deep plum calm
    },
    'other': {
        light: '#d6c8ff',
        mid: '#b69cff',
        dark: '#432d82'
    },
    'temp': {
        light: '#d9f0e4',   // soft alpine mist
        mid: '#4caf7b',     // fresh pine green
        dark: '#1e4d36',    // deep evergreen
    }
}